import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './ApproveTeacher.css';

const ApproveTeacher = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const approveTeacher = async () => {
      try {
        const response = await api.get(`/auth/questionnaire/approve/${token}/`);
        setStatus('success');
        setMessage(response.data.message || 'Анкета подтверждена. Письмо с данными для входа отправлено на email.');
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.error || 'Ошибка при подтверждении анкеты. Попробуйте еще раз.');
      }
    };

    if (token) {
      approveTeacher();
    }
  }, [token]);

  return (
    <div className="approve-teacher-page">
      <Header forceUnauthenticated={true} />
      <div className="approve-teacher-container">
        <div className="approve-teacher-box">
          {status === 'loading' && (
            <>
              <div className="approve-icon loading">⏳</div>
              <h1>Обработка запроса...</h1>
              <p>Пожалуйста, подождите</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <div className="approve-icon success">✅</div>
              <h1>Письмо с данными для входа отправлено</h1>
              <p className="success-message">{message}</p>
              <button 
                onClick={() => navigate('/')} 
                className="btn-primary"
              >
                Вернуться на главную
              </button>
            </>
          )}
          
          {status === 'error' && (
            <>
              <div className="approve-icon error">❌</div>
              <h1>Ошибка</h1>
              <p className="error-message">{message}</p>
              <button 
                onClick={() => navigate('/')} 
                className="btn-primary"
              >
                Вернуться на главную
              </button>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ApproveTeacher;
